"use client";

import { MarkdownTable } from "./markdown-table/MarkdownTable";
import { MarkdownTableTh } from "./markdown-table/MarkdownTableTh";
import { MarkdownTableTd } from "./markdown-table/MarkdownTableTd";

export const markdownTableComponents = {
  table: (props: any) => <MarkdownTable {...props} />,
  th: (props: any) => <MarkdownTableTh {...props} />,
  td: (props: any) => <MarkdownTableTd {...props} />,
};
